<template>
  <PageHeader
    :handleLogout="logoutUser"
    :userName="userData.email"
    userLink="/users/me"
    :has-top-nav="false"
    :show-brand-logo="false"
    header-classes="''"
  >
    <template slot="logo">
      <div class="logo-wrapper" style="margin-left: 15px">
        <div class="mz-logo__wrapper mz_logo__redirect" @click="$router.push({name: 'Home'})">
          <img
            src="/img/gareat.png"
            alt="logo"
            class="img-navbar gareat-logo"
          />
        </div>
      </div>
    </template>
    <template slot="center-elements">
      <span class="welcome-message">
        {{$t("Welcome")}}
        <i class="text-capitalize">{{
          fullName
        }}</i>
      </span>
    </template>
    <template slot="tools__search">
      <div class="d-flex align-items-center">
        <CSelect
          class="mt-3"
          :value="$store.state.language"
          :options="languages"
          @update:value="setLanguage"
        />
      </div>
    </template>
    <template slot="additional-left-elements__partner-view"><div /></template>
    <template slot="tools__help">
      <CButton
        class="mz-icon icon-help mr-3 ml-2"
        @click="
          $downloadFile({
            fileId: 3,
            name: $t('Platform_Tutorial_SMR_Gareat_ENG_User.pdf'),
          })
        "
      />
    </template>
  </PageHeader>
</template>

<script>
import { ActiveUser } from "@/services/user";

import { LanguageMixin } from "@/mixins/language";

export default {
  name: "ThePageHeader",
  mixins: [LanguageMixin],
  data() {
    return {
      userData: ActiveUser.get(),
    };
  },
  computed: {
    fullName() {
      if (this.userData.firstname && this.userData.lastname) {
        return this.userData.firstname + " " + this.userData.lastname;
      }
      return this.userData.email;
    }
  },
  methods: {
    logoutUser() {
      ActiveUser.clear();
      this.$router.replace("/account/login");
    },
  },
};
</script>

<style lang="scss">
.icon-help {
  font-size: 24px;
  &:hover {
    color: $primary-indigo-dye;
    transition: color 0.2s ease-in-out;
  }
}

.mz_logo__redirect:hover {
  cursor: pointer;
}
</style>
